// Product catalogue data for Terra Bloom Studio.
// Swap any `image` URL to point at real product photography.

const products = [
  {
    id: "TBS-SPD-001",
    name: "Ivory Rose Bouquet",
    code: "TBS-SPD-001",
    image: "/Assets/handicrafts/image1.jpeg",
    category: "Sola & Pith Crafts",
  },
  {
    id: "TBS-WB-002",
    name: "Wedding Bouquet",
    code: "TBS-WB-002",
    image: "/Assets/handicrafts/image2.jpeg",
    category: "Bridal & Wedding",
  },
  {
    id: "TBS-LBB-003",
    name: "Luxury Bridal Bouquet",
    code: "TBS-LBB-003",
    image: "/Assets/handicrafts/image3.jpeg",
    category: "Bridal & Wedding",
  },
  {
    id: "TBS-RPB-004",
    name: "Royal Purple Bridal Bouquet",
    code: "TBS-RPB-004",
    image: "/Assets/handicrafts/image4.jpeg",
    category: "Bridal & Wedding",
  },
  {
    id: "TBS-MQB-005",
    name: "Majantha Queen Bouquet",
    code: "TBS-MQB-005",
    image: "/Assets/handicrafts/image5.jpeg",
    category: "Bridal & Wedding",
  },
  {
    id: "TBS-TTA-006",
    name: "Table Top Arrangement",
    code: "TBS-TTA-006",
    image: "/Assets/handicrafts/image6.jpeg",
    category: "Home & Table Decor",
  },
  {
    id: "TBS-MRP-007",
    name: "Mini Rainbow Pot",
    code: "TBS-MRP-007",
    image: "/Assets/handicrafts/image7.jpeg",
    category: "Home & Table Decor",
  },
  {
    id: "TBS-ALR-008",
    name: "Natural Areca Leaf Rose",
    code: "TBS-ALR-008",
    image: "/Assets/handicrafts/image8.jpeg",
    category: "Areca Leaf Crafts",
  },
  {
    id: "TBS-ARS-009",
    name: "Sola/Areca Leaf Rose Stick",
    code: "TBS-ARS-009",
    image: "/Assets/handicrafts/image9.jpeg",
    category: "Areca Leaf Crafts",
  },
  {
    id: "TBS-PPB-010",
    name: "Pistachio Petal Blossom",
    code: "TBS-PPB-010",
    image: "/Assets/handicrafts/image10.jpeg",
    category: "Shell & Nut Crafts",
  },
  {
    id: "TBS-CSB-011",
    name: "Coconut Shell Basket Flower",
    code: "TBS-CSB-011",
    image: "/Assets/handicrafts/image11.jpeg",
    category: "Shell & Nut Crafts",
  },
  {
    id: "TBS-PCP-012",
    name: "Paddy Coated Pot",
    code: "TBS-PCP-012",
    image: "/Assets/handicrafts/image12.jpeg",
    category: "Paddy & Grain Crafts",
  },
  {
    id: "TBS-PSH-013",
    name: "Paddy Sheaf Hanging",
    code: "TBS-PSH-013",
    image: "/Assets/handicrafts/image13.jpeg",
    category: "Paddy & Grain Crafts",
  },
  {
    id: "TBS-BWH-014",
    name: "Bird Wreath Wall Hanging",
    code: "TBS-BWH-014",
    image: "/Assets/handicrafts/image14.jpeg",
    category: "Wall Hangings",
  },
  {
    id: "TBS-RWH-015",
    name: "Ribbon Rose Wall Hanging",
    code: "TBS-RWH-015",
    image: "/Assets/handicrafts/image15.jpeg",
    category: "Wall Hangings",
  },
  {
    id: "TBS-SLC-016",
    name: "Skeleton Leaf Craft",
    code: "TBS-SLC-016",
    image: "/Assets/handicrafts/image16.jpeg",
    category: "Wall Hangings",
  },
  {
    id: "TBS-RWV-017",
    name: "Rustic Wine Bloom Vase",
    code: "TBS-RWV-017",
    image: "/Assets/handicrafts/image17.jpeg",
    category: "Home & Table Decor",
  },
  {
    id: "TBS-RLV-018",
    name: "Rainbow Leaf Bud Vase",
    code: "TBS-RLV-018",
    image: "/Assets/handicrafts/image18.jpeg",
    category: "Home & Table Decor",
  },
  {
    id: "TBS-IMP-019",
    name: "Ivory Maroon Sola Posy",
    code: "TBS-IMP-019",
    image: "/Assets/handicrafts/image19.jpeg",
    category: "Bridal & Wedding",
  },
  {
    id: "TBS-GIR-020",
    name: "Golden Ivory Rose Bunch",
    code: "TBS-GIR-020",
    image: "/Assets/handicrafts/image20.jpeg",
    category: "Sola & Pith Crafts",
  },
  {
    id: "TBS-CVH-021",
    name: "Curved Vine Floral Hanging",
    code: "TBS-CVH-021",
    image: "/Assets/handicrafts/image21.jpeg",
    category: "Wall Hangings",
  },
  {
    id: "TBS-FTC-022",
    name: "Festive Topiary Centerpiece",
    code: "TBS-FTC-022",
    image: "/Assets/handicrafts/image22.jpeg",
    category: "Home & Table Decor",
  },
  {
    id: "TBS-BSS-023",
    name: "Bamboo Stick Bunch Stand",
    code: "TBS-BSS-023",
    image: "/Assets/handicrafts/image23.jpeg",
    category: "Home & Table Decor",
  },
  {
    id: "TBS-CRB-024",
    name: "Crimson Rose Ball Bouquet",
    code: "TBS-CRB-024",
    image: "/Assets/handicrafts/image24.jpeg",
    category: "Bridal & Wedding",
  },
  {
    id: "TBS-CRS-025",
    name: "Classic Red Rose Stem",
    code: "TBS-CRS-025",
    image: "/Assets/handicrafts/image25.jpeg",
    category: "Sola & Pith Crafts",
  },
  {
    id: "TBS-WSB-026",
    name: "Wavy Stem Bouquet Set",
    code: "TBS-WSB-026",
    image: "/Assets/handicrafts/image26.jpeg",
    category: "Wall Hangings",
  },
  {
    id: "TBS-BVD-027",
    name: "Bamboo Vase Floral Display",
    code: "TBS-BVD-027",
    image: "/Assets/handicrafts/image27.jpeg",
    category: "Home & Table Decor",
  },
  {
    id: "TBS-MWC-028",
    name: "Magenta Wave Carnation Spray",
    code: "TBS-MWC-028",
    image: "/Assets/handicrafts/image28.jpeg",
    category: "Wall Hangings",
  },
  {
    id: "TBS-AWB-029",
    name: "Assorted Wavy Bouquet Collection",
    code: "TBS-AWB-029",
    image: "/Assets/handicrafts/image29.jpeg",
    category: "Wall Hangings",
  },
  {
    id: "TBS-SRV-030",
    name: "Sunset Rose Vase Set",
    code: "TBS-SRV-030",
    image: "/Assets/handicrafts/image30.jpeg",
    category: "Home & Table Decor",
  },
  {
    id: "TBS-BFM-031",
    name: "Bamboo Stand Floral Medley",
    code: "TBS-BFM-031",
    image: "/Assets/handicrafts/image31.jpeg",
    category: "Home & Table Decor",
  },
  {
    id: "TBS-IBG-032",
    name: "Ivory Blossom Gift Basket",
    code: "TBS-IBG-032",
    image: "/Assets/handicrafts/image32.jpeg",
    category: "Bridal & Wedding",
  },
  {
    id: "TBS-MRV-033",
    name: "Maroon Rose Vase Arrangement",
    code: "TBS-MRV-033",
    image: "/Assets/handicrafts/image33.jpeg",
    category: "Home & Table Decor",
  },
  {
    id: "TBS-IRS-034",
    name: "Ivory Rose Stem",
    code: "TBS-IRS-034",
    image: "/Assets/handicrafts/image34.jpeg",
    category: "Sola & Pith Crafts",
  },
];

export default products;
